<template>
  <div>
    <div class="notification">
      <span @click="notificationPanel = !notificationPanel">
         <b-icon
             icon="check2-square"
             aria-hidden="true"
             variant="warning"
             scale="1.5"
         />
      </span>
      <div
        class="overlay"
        v-if="notificationPanel"
        @click="notificationPanel = false"
      ></div>
      <transition name="fade">
        <div class="notifications-panel" v-if="notificationPanel">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="title">To->Done</h4>
            <a v-if="false" class="see-all" href="">See All</a>
          </div>
          <div class="noti-list">
            <div
              class="noti-msg"
              v-for="(notification, index) in serveNotificationsList"
              :class="{ 'no-border': index == 0 }"
              :key="index"
            >
              <div class="usr-img">
                <img
                  v-if="
                    notification &&
                      notification.user_from &&
                      notification.user_from.imgURL
                  "
                  :src="notification.user_from.imgURL"
                  alt=""
                />
              </div>
              <div class="noti-info">
                <div class="d-flex justify-content-between align-items-center">
                  <h3
                    v-if="
                      notification &&
                        notification.user_from &&
                        notification.user_from.name
                    "
                    class="name"
                  >
                    {{ notification.user_from.name }}
                  </h3>
                  <div>
                    <time-ago
                      :refresh="60"
                      :datetime="notification._created_at.toDate()"
                    />
                    ago
                  </div>
                </div>
                <h6 class="usr-msg">{{ notification.text }}</h6>
                <div
                  class="actions d-flex justify-content-start align-items-center"
                >
                  <a
                    v-for="(aButton, index) in notification.options"
                    @click="handleResponseInvitation('joined', notification)"
                    :class="aButton.class"
                    :key="index"
                    >{{ aButton.text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- <a-dropdown :trigger="['click']" placement="bottomLeft">
      <div :class="$style.dropdown">
        <a-badge :count="count" :class="$style.user_profile_badge">
          <i class="fa fa-bell-o fa-lg" />
        </a-badge>
      </div>
      <a-menu slot="overlay">
        <a-menu-item v-if="serveNotificationsList.length == 0">
          No Notifications atm
        </a-menu-item>
        <a-menu-item
          v-for="(aNotification, index) in serveNotificationsList"
          :key="index"
        >
          <a href="javascript: void(0);" @click="handleNotifcationClick">
            <i :class="$style.message" class="fe fe-bell"></i>
            {{ serveNotificationsList.length }} Notification
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <b-modal
      id="modal-notifcations"
      size="md"
      title="Notifications"
      v-model="showModalNotifications"
      hide-footer
    >
      <b-container>
        <b-row
          class="mb-2"
          v-for="(aNotification, index) in serveNotificationsList"
          :key="index"
        >
          <b-col cols="8">
            {{ aNotification.text }}
          </b-col>
          <b-col
            v-if="aNotification.type === 'invitation' && !aNotification._answer"
          >
            <b-button
              @click="handleResponseInvitation('joined', aNotification)"
              variant="success"
              class="mr-2"
            >
              Join
            </b-button>
            <b-button
              @click="handleResponseInvitation('rejected', aNotification)"
              variant="danger"
              style="height:35.25px"
            >
              Reject
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal> -->
  </div>
</template>

<script>
import TimeAgo from "vue2-timeago";
export default {
  name: "notifications-menu",
  components: { TimeAgo },
  methods: {
    handleNotifcationClick() {
      this.showModalNotifications = true;
    },
    handleResponseInvitation(resp, notif) {
      this.$store.dispatch("user/actionResponseInvitationJourney", {
        response: resp,
        notif
      });
      this.showModalNotifications = false;
    }
  },
  computed: {
    serveNotificationsList() {
      return this.$store.getters["user/listNotifications"].filter(
        el => !el._answer
      );
    },
    count() {
      return this.serveNotificationsList.length;
    }
  },
  mounted() {
    this.$store.dispatch("user/getListNotifications");
  },
  data() {
    return {
      notificationPanel: false,
      showModalNotifications: true
    };
  }
};
</script>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(189, 189, 189, 0);
  z-index: 8;
}
.notification {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  span {
    cursor: pointer;
  }
  .red-dot {
    position: absolute;
    top: -6px;
    left: 50%;
  }

  .notifications-panel {
    z-index: 10;
    padding: 20px 10px;
    position: absolute;
    border-radius: 10px;
    width: 316px;
    top: 40px;
    right: -100px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0 #eee;
    div {
      margin: 0;
    }
    .title {
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      /* identical to box height */

      /* Secondary */

      color: #8d99a0;
    }
    .see-all {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      /* identical to box height */

      /* Primary */

      color: var(--theme-color);
      text-decoration: none;
    }
    .noti-list {
      padding: 0 8px 24px 24px;
      max-height: 70vh;
      overflow-y: scroll;
      margin-right: 8px;
      &::-webkit-scrollbar {
        height: 0px;
        width: 8px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
        // width: 4px !important;
      }
      .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);
        display: flex;
        justify-content: center;
        align-items: center;
        .btn-green {
          background-color: #65ea82;
          max-width: 80%;
          margin-top: 12px;
          margin-bottom: 12px;
        }
      }
      .tool {
        position: relative;
        background: #ffffff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        margin-bottom: 8px;
        &.active {
          background: rgba(85, 126, 251, 0.1);
        }
        .ico {
          position: absolute;
          right: 18px;
          top: 22px;
        }
        .content__tool {
          cursor: pointer;
          padding: 18px;
          .info {
            display: grid;
            grid-template-columns: 32px 1fr;
            grid-column-gap: 14px;
            align-items: center;
            img {
              height: 32px;
              width: 32px;
            }
            h4 {
              margin: 0;
              font-weight: normal;
              font-size: 16px;
              line-height: 22px;
              color: #474d52;
            }
          }
        }
      }
    }
    .noti-msg {
      padding: 10px 0;
      border-top: 2px solid #d9d9d9;
      &.no-border {
        border: none;
      }
      display: grid;
      grid-template-columns: 45px 1fr;
      .name {
        font-size: 14px;
        line-height: 19px;
        font-weight: bold;
        color: #474d52;
      }
      .time {
        font-family: "Nunito", sans-serif;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
      .usr-msg {
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        /*margin-top: 6px;*/
      }
      .btn-fill,
      .btn-outline {
        /*margin-top: 12px;*/
        margin-left: 0;
        padding: 5px 15px;
        border-radius: 5px;
        text-decoration: none;
        font-weight: normal;
        font-size: 14px;
      }
      .btn-outline {
        border: none;
        &:hover {
          color: var(--theme-color);
        }
      }
      .btn-fill {
        &:hover {
          color: #fff;
        }
      }
      .usr-img {
        img {
          height: 40px;
          width: 40px;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .actions .accept {
        color: #fff;
      }
    }
  }
}
</style>
